/**
 * Main page implementation.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';


var Page = require('stb-component-page'),

    dom  = require('spa-dom'),
    keys = require('stb-keys'),
    app  = require('mag-app'),

    Layout     = require('mag-component-layout'),
    LayoutList = require('mag-component-layout-list'),
    ScrollBar  = require('stb-component-scrollbar'),
    ScrollArea = require('mag-component-scroll-area'),

    utils = {
        toggleFavorite: require('../utils/toggle.favorite')
    },

    page = new Page({$node: document.getElementById('pageMore')}),

    infoBlock, buttonList, infoData,

    buttons, buttonsData, buttonsDataWatch,
    buttonsSerialsWatch,

    // prevPage,
    // screenList, seasonsList, seasonsButton,
    scroll,

    textArea = new ScrollArea({
        propagate: true,
        step: 5,
        scroll: scroll = new ScrollBar({}),
        events: {
            overflow: function ( event ) {
                if ( event.direction === keys.down ) {
                    buttonList.focus();
                }
            }
        }
    });

/**
 * Change favorite state.
 */
function toggleFavorite () {
    if ( infoData.favorite ) {
        buttonList.$node.classList.remove('inFavorite');
    } else {
        buttonList.$node.classList.add('inFavorite');
    }
    utils.toggleFavorite(infoData);
}

buttons = {
    continueWatching: {
        icon: 'theme-icon theme-icon-play',
        value: gettext('Continue watching'),
        click: function () {
            app.route(app.pages.info, {info: null, type: 'continue'});
        }
    },
    watchAgain: {
        icon: 'theme-icon theme-icon-reset',
        value: gettext('Watch again'),
        click: function () {
            app.route(app.pages.info, {info: null, type: 'start'});
        }
    },
    favorite: {
        icon: 'theme-icon theme-icon-favorite-active',
        value: gettext('Favorite'),
        click: toggleFavorite
    },
    play: {
        icon: 'theme-icon theme-icon-play',
        value: gettext('Play'),
        click: function () {
            app.route(app.pages.info, {info: null, type: 'start'});
        }
    }
};

buttonsData = [buttons.play, buttons.favorite];
buttonsDataWatch = [buttons.continueWatching, buttons.watchAgain, buttons.favorite];
buttonsSerialsWatch = [buttons.continueWatching, buttons.favorite];

page.add(textArea);
page.add(scroll);

infoBlock = require('../utils/init.info')();

buttonList = new LayoutList({
    cycle: false,
    className: 'buttonList',
    render: function ( $item, config ) {
        var layout, focus, icon,
            button;

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }
        button = dom.tag('div', {className: 'button'});
        icon = dom.tag('div', {className: config.icon});
        button.appendChild(icon);

        focus = dom.tag('div', {className: 'buttonFocus'});
        icon = dom.tag('div', {className: config.icon});
        focus.appendChild(icon);

        while ( $item.firstChild ) {
            $item.removeChild($item.firstChild);
        }

        layout = new Layout({
            focusable: false,
            data: [button, {className: 'buttonTitle', value: config.value}, focus]
        });

        $item.appendChild(layout.$node);
        $item.layout = layout;
        layout.parent = this;
        layout.$parentItem = $item;

        // focus layoutList if click on layout
        layout.addListener('click', function () {
            // add inner property to set that event comes from inner component
            layout.parent.emit('click:item', {$item: $item, inner: true});
        });

        if ( config.click ) {
            this.handlers[$item.index] = config.click;
        }
        // item is rendered
        $item.ready = true;

        $item.value = config.value || {};
    },
    data: [],
    size: app.metrics.buttonList.size,
    focusIndex: 0,
    propagate: false,
    type: LayoutList.prototype.TYPE_HORIZONTAL,
    events: {
        keydown: function ( event ) {
            switch ( event.code ) {
                case keys.up:
                    event.stop = true;
                    textArea.focus();
                    break;
                case keys.down:
                    event.stop = true;
                    break;
                case keys.right:
                case keys.left:
                    // cursor move only on arrow keys
                    this.move(event.code);
                    event.stop = true;
                    break;
                case keys.enter:
                    // there are some listeners
                    if ( this.events['click:item'] && this.$focusItem ) {
                        // notify listeners
                        this.emit('click:item', {$item: this.$focusItem, event: event});
                    }
                    event.stop = true;
                    break;
            }
        }
    }
});


textArea.$body.appendChild(infoBlock.$body);
infoBlock.$panel.appendChild(buttonList.$node);


/**
 * Fill pages layouts.
 */
page.addListener('show', function ( data ) {
    if ( !data || !data.data ) {
        return;
    }

    infoData = data.data;

    if ( infoData.poster ) {
        infoBlock.$img.style.backgroundImage = infoData.poster;
    } else {
        infoBlock.$img.style.backgroundImage = '';
    }

    infoBlock.$title.innerText = infoData.name;
    infoBlock.$country.innerText = ( infoData.year_end ? infoData.year + ' - ' + infoData.year_end : infoData.year ) + ', ' +
        infoData.genre + ', ' + infoData.duration + ' ' + gettext('minutes');

    if ( infoData['rating_kinopoisk'] ) {
        infoBlock.$ratingKino.innerText = infoData.rating_kinopoisk;
        infoBlock.$ratingKino.style.display = '';
    } else {
        infoBlock.$ratingKino.style.display = 'none';
    }
    if ( infoData['rating_imdb'] ) {
        infoBlock.$ratingImdb.innerText = infoData.rating_imdb;
        infoBlock.$ratingImdb.style.display = '';
    } else {
        infoBlock.$ratingImdb.style.display = 'none';
    }
    if ( infoData.age ) {
        infoBlock.$censor.innerText = infoData.age;
        infoBlock.$censor.style.display = '';
    } else {
        infoBlock.$censor.style.display = 'none';
    }
    infoBlock.$director.innerText = infoData.director;
    infoBlock.$actors.innerText = infoData.actors;

    infoBlock.$description.innerText = infoData.description;
    if ( infoData.watched_status === 'not_ended' ) {
        buttonList.setData({data: buttonsDataWatch, focusIndex: 0});
        if ( infoData['is_tv_series'] ) {
            buttonList.setData({data: buttonsSerialsWatch, focusIndex: 0});
        }
    } else {
        buttonList.setData({data: buttonsData, focusIndex: 0});
    }

    if ( infoData.favorite ) {
        buttonList.$node.classList.add('inFavorite');
    } else {
        buttonList.$node.classList.remove('inFavorite');
    }

    textArea.init();
    textArea.focus();
});


if ( DEVELOP ) {
    window.infoBlockMore = infoBlock;
    window.textArea = textArea;
}


page.addListener('keydown', function ( event ) {
    switch ( event.code ) {
        case keys.back:
            app.route(app.pages.info, {type: 'back'});
            break;
        case keys.f3:
            toggleFavorite();
            break;
    }
});

module.exports = page;
